import { ClientPb, ServerPb } from 'fifty-seven-llc-protocol';
import { api } from '../common/api';
import { AuthorizationErrorEnum } from 'fifty-seven-llc-common';
import { store } from '../../store';

class AuthorizationService {
  signIn(login, password) {
    return new Promise((resolve, reject) => {
      fetch(`${process.env.VUE_APP_URL}/authorization/sign_in`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ login, password }),
      })
        .then(res => res.json())
        .then(res => {
          if (res.hasOwnProperty('error')) {
            switch (res.error) {
              case AuthorizationErrorEnum.invalidLogin:
              case AuthorizationErrorEnum.invalidPassword: {
                reject('Invalid login or password.');
                break;
              }

              case AuthorizationErrorEnum.internalServer: {
                reject('Internal server error.');
                break;
              }

              default: {
                reject(res.error);
              }
            }
          } else {
            resolve(res.result.accessToken);
          }
        })
        .catch(err => {
          reject(err.message);
        });
    });
  }

  signOut() {
    return new Promise((resolve, reject) => {
      store.dispatch('account/clearList');
      store.dispatch('company/clearList');
      store.dispatch('permission/clearList');

      fetch(`${process.env.VUE_APP_URL}/authorization/sign_out`)
        .then(res => resolve())
        .catch(err => reject(err.message));
    });
  }

  authorize(accessToken) {
    return new Promise(resolve => {
      const callback = message => {
        if (message instanceof ServerPb.Authorize) {
          if (message.hasError()) {
            switch (message.getError()) {
              case AuthorizationErrorEnum.accessTokenIsInvalid:
              case AuthorizationErrorEnum.internalServer: {
                resolve(false);
              }
            }
          } else {
            try {
              const accessTokenData = JSON.parse(atob(accessToken.split('.')[1]));
              if (!accessTokenData['accountId']) return resolve(false);

              resolve(true);
            } catch (err) {
              console.error(err);
              resolve(false);
            }
          }

          api.off('message', callback);
        }
      };

      api.on('message', callback);

      const message = new ClientPb.Authorize();
      message.setAccessToken(accessToken);
      api.send(message, true);
    });
  }

  refreshToken() {
    return new Promise(resolve => {
      fetch(`${process.env.VUE_APP_URL}/authorization/refresh_token`)
        .then(res => res.json())
        .then(res => {
          if (res.hasOwnProperty('error')) {
            console.error('Authorization error:', AuthorizationErrorEnum[res.error] || res.error);
            resolve(null);
          } else {
            resolve(res.result.accessToken);
          }
        })
        .catch(err => resolve(null));
    });
  }
}

export const authorizationService = new AuthorizationService();
